import { createSelector } from '@ngrx/store';
import { selectCurrentAttachments } from './attachments.selector';
import { selectShare } from './share.selector';

export const selectText = createSelector(
  selectShare,
  selectCurrentAttachments,
  (shareState:any, currentAttachments) => {
    let text;
    const {share: instance, result:{entities}} = shareState;
    if (instance && entities && entities.texts) {
      const noteText = entities.texts[instance.note];
      const decodedText = decodeText(
        (noteText && noteText.text) ? noteText.text : "",
        currentAttachments
      );
      text = Object.assign({}, noteText, {text: decodedText});
    }
    return text;
  }
);

function decodeText(text, attachments) {
  let textResult: string = text;
  if (attachments) {
    const regExp = /(["'])#attacheloc:([A-z0-9]{16,24})#(["'])/g;
    const attachmentSrcs = textResult.match(regExp);
    if (attachmentSrcs) {
      attachmentSrcs.forEach((attachmentSrc) => {
        const regExp = /(["'])#attacheloc:([A-z0-9]{16,24})#(["'])/g;
        const result = regExp.exec(attachmentSrc);
        const attachment = getAttachment(result[2], attachments);
        if (attachment) {
          textResult = textResult.replace(attachmentSrc,
            '"/box' + attachment.attachmentURL + '" data-attachment-id="'+ attachment.globalId +'"' );
        }
      });
    }
  }
  textResult = textResult.replace('<table', '<div class="nns-table-holder"><table');
  textResult = textResult.replace('</table>', '</table></div>');
  return textResult;
}

function getAttachment(globalId, attachments) {
  let result;
  attachments.forEach((attachment) => {
    if (attachment.globalId && (attachment.globalId.indexOf(globalId) >= 0)) {
      result = attachment;
    }
  });
  return result;
}
